if (!document.getElementById("employer-create-job")) return;

function isQuillEmpty(html) {
    const cleaned = html
        .replace(/<(.|\n)*?>/g, '')  // remove all tags
        .replace(/&nbsp;/g, '')
        .trim();

    return cleaned.length === 0;
}

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

// Hide unused buttons if they exist
const confirmUpdate = document.querySelector(
  ".custom-message-modal-btn.confirm"
);
const confirmBtnCancel = document.querySelector(
  ".custom-message-modal-btn.btn-delete.cancel"
);

if (confirmUpdate) confirmUpdate.style.display = "none";
if (confirmBtnCancel) confirmBtnCancel.style.display = "none";

const modal = document.querySelector(".custom-message-modal-overlay");
if (modal) {
  modal.addEventListener("click", function (e) {
    if (
      e.target.classList.contains("updated") ||
      e.target.classList.contains("job-detail")
    ) {
      modal.classList.remove("d-flex");
      e.target.remove();
    }
  });
}

function employerCreateJobModal(message, title = "Attention Required") {
  const modalTitle = document.querySelector(".custom-message-modal-title");
  const modalFooter = document.querySelector(".custom-message-modal-footer");
  const confirmButton = document.createElement("button");
  confirmButton.className =
    "custom-message-modal-btn btn btn-primary btn-xs job-detail";
  confirmButton.textContent = "Ok";

  if (modalTitle) modalTitle.innerHTML = title;

  if (modalFooter) {
    modalFooter.appendChild(confirmButton);
  }

  const modalMessage = document.querySelector(".custom-message-modal-body");
  if (modalMessage) {
    modalMessage.innerHTML = message;
  }

  const modalTriggerBtn = document.querySelector(".open-modal-btn");
  if (modalTriggerBtn) {
    modalTriggerBtn.click();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const benefitCheckboxes = document.querySelectorAll(
    '.working-environment input[type="checkbox"]'
  );
  if (benefitCheckboxes) {
    let selected = [];
    benefitCheckboxes.forEach((benefit) => {
      benefit.addEventListener("change", () => {
        if (benefit.checked) {
          selected.push(benefit);
          if (selected.length > 3) {
            const first = selected.shift();
            first.checked = false;
          }
        } else {
          selected = selected.filter((item) => item !== benefit);
        }
      });
    });
  }
});

function countWysyigCharacter(inputText) {
  let tempDiv = document.createElement("div");
  tempDiv.innerHTML = inputText;
  let textOnly = tempDiv.textContent || tempDiv.innerText || "";
  let charCount = textOnly.length;
  return charCount;
}



// Form submission handler
const employerCreateJob = document.getElementById("employer-create-job");
employerCreateJob.addEventListener("keydown", function (e) {
  if (e.key === "Enter") {
    e.preventDefault();
  }
});



employerCreateJob.addEventListener("submit", function (event) {
  event.preventDefault();
  const submitBtn = document.querySelector(".submit-btn");
  const currentDate = new Date();
  let startDate, endDate;

  submitBtn.disabled = true;

  if (document.querySelector(".custom-message-modal-btn.updated")) {
    document.querySelector(".custom-message-modal-btn.updated").remove();
  }

  if (document.querySelector(".custom-message-modal-btn.job-detail")) {
    document.querySelector(".custom-message-modal-btn.job-detail").remove();
  }

  const jobTitle = document.getElementById("job-title").value.trim();
  const jobId = Number(document.getElementById("job-id").value);

  const clinicalRole = document.querySelector(
    'input[name="work-type"]:checked'
  ).value;

  let jobCategory = '';
  if( clinicalRole != 'other' ) {
    jobCategory = document
    .getElementById(`job-category-${clinicalRole}`)
    .value.trim();
  }
    
  const jobLocation = document.getElementById("job-location").value.trim();
  const startDateInput = document.getElementById("start-date").value.trim();
  const endDateInput = document.getElementById("end-date").value.trim();

  const hoursPerWeek = document.getElementById("hours-per-week").value.trim();
  const industrySector = document
    .getElementById("industry-sector")
    .value.trim();

  // pushing the textarea div element to   text area element
  if (window.quillEditors && window.quillEditors.length > 0) {
    window.quillEditors.forEach(({ quill, textarea }) => {
      if (textarea) {
        textarea.value = quill.root.innerHTML;
      }
    });
  }

  const jobDescription = document
    .getElementById("job-description")
    .value.trim();

  // Job description validation
  const descFileInput = document.getElementById('upload-description');
  // const qualFileInput = document.getElementById('upload-qualifications');
  // const beniFileInput = document.getElementById('upload-qualifications');
  const maxSize = 5 * 1024 * 1024; // 5MB

  const qualifications = document
    .getElementById("qualifications-required")
    .value.trim();
  const benefits = document.getElementById("benefits").value.trim();
  const howToApply = document.getElementById("how-to-apply").value.trim();

  const availableToStart = document.getElementById("work-start").value.trim();
  const jobType = document.getElementById("job-type").value.trim();
  const minSalary = document.getElementById("min-salary").value.trim();
  const maxSalary = document.getElementById("max-salary").value.trim();

  const businessEmployerName = document
    .getElementById("employer-name")
    .value.trim();
  const businessWebsite = document
    .getElementById("business-website")
    .value.trim();
  const contactName = document.getElementById("contact-name").value.trim();
  const contactPhone = document.getElementById("contact-phone").value.trim();
  const contactEmail = document.getElementById("contact-email").value.trim();
  // const benefitsChecked = document.querySelectorAll('.working-environment input[type="checkbox"]:checked').length;

  const termsCondition = document.getElementById("terms-condition");

  const errors = [];

  if (jobTitle == "") {
    errors.push({
      message: "Job title is required",
      scrollDiv: ".site-main--contents",
      attrId: "job-title",
    });
  } else {
    const wordCount = jobTitle.length;
    if (wordCount < 3 || wordCount > 100) {
      errors.push({
        message:
          'Job title must contain between 3 and 50 characters.',
          scrollDiv: ".site-main--contents",
          attrId: "job-title",
      });
    }
  }
  if ((jobCategory == "") && (clinicalRole!='other')) {
    errors.push({
      message: "Select a category for job",
      scrollDiv: ".site-main--contents",
      attrId: `field-job-${clinicalRole}`,
    });
  }
  if (jobLocation == "") {
    errors.push({
      message: "Job location is required",
      scrollDiv: "#job-title",
      attrId: "job-location",
    });
  } else {
    const nameRegex = /^[a-zA-Z0-9\s,\-.'’]{3,100}$/;
    if (!nameRegex.test(jobLocation)) {
      errors.push({
        message:
          'Location must be alphanumeric of 3-100 characters may include "spaces, commas, hyphens, dots and apostrophes"',
        scrollDiv: "#job-title",
        attrId: "job-location",
      });
    }
  }
  if( jobId == '' ) {
    if (startDateInput === "") {
      errors.push({
        message: "Ad start date is required",
        scrollDiv: "#job-title",
        attrId: "start-date",
      });
    } else {
      currentDate.setHours(0, 0, 0, 0);
      startDate = new Date(startDateInput);
      startDate.setHours(0, 0, 0, 0);
      if (startDate < currentDate) {
        errors.push({
          message: "Ad start date must be today or later",
          scrollDiv: "#job-title",
          attrId: "start-date",
        });
      }
    }
  }
  if (endDateInput === "") {
    errors.push({
      message: "Ad end date is required",
      scrollDiv: "#job-title",
      attrId: "end-date",
    });
  } else {
    endDate = new Date(endDateInput);
    endDate.setHours(0, 0, 0, 0);
    if (startDate && endDate <= startDate) {
      errors.push({
        message: "Ad end date must be after the start date",
        scrollDiv: "#job-title",
        attrId: "end-date",
      });
    }
  }
  if (hoursPerWeek == "") {
    errors.push({
      message: "Select job hours/week",
      scrollDiv: "#job-location",
      attrId: "hours-per-week",
    });
  }
  if (industrySector == "") {
    errors.push({
      message: "Select industry sector",
      scrollDiv: "#job-location",
      attrId: "field-industry-sector",
    });
  }

  if (descFileInput && descFileInput.files.length > 0) {
      const descFile = descFileInput.files[0];

      if (descFile.size > maxSize) {
          errors.push({
              message: 'File size exceeds 5MB. Please upload a smaller file.',
              scrollDiv: '#field-description',
              attrId: 'field-description'
          });
      }
  } else if (jobDescription == "" ) {
    errors.push({
      message: "Job description is required",
      scrollDiv: "#hours-per-week",
      attrId: "job-description",
    });
  } else {
    if (
      countWysyigCharacter(jobDescription) < 2 ||
      countWysyigCharacter(jobDescription) > 5000
    ) {
      errors.push({
        message: "Please enter text between 2 and 5000 characters",
        scrollDiv: "#hours-per-week",
        attrId: "job-description",
      });
    }
  }




  /*if (qualifications == "") {
    errors.push({
      message: "Qualification is required",
      scrollDiv: ".job-description-field",
      attrId: "qualifications-required",
    });
  } else*/


  if( !isQuillEmpty(qualifications) ){
      if (
        countWysyigCharacter(qualifications) < 2 ||
        countWysyigCharacter(qualifications) > 5000
      ) {
        errors.push({
          message: "Please enter text between 2 and 5000 characters",
          scrollDiv: ".job-description-field",
          attrId: "qualifications-required",
        });
      }
  }

  /*if (benefits == "") {
    errors.push({
      message: "Benefits is required",
      scrollDiv: ".qualifications-field",
      attrId: "benefits",
    });
  } else*/

  if(!isQuillEmpty(benefits)) {
    if (
      countWysyigCharacter(benefits) < 2 ||
      countWysyigCharacter(benefits) > 5000
    ) {
      errors.push({
        message: "Please enter text between 2 and 5000 characters",
        scrollDiv: ".qualification-field",
        attrId: "benefits",
      });
    }
  }
  /*if (howToApply == "") {
    errors.push({
      message: "Required How to apply",
      scrollDiv: ".benefits-field",
      attrId: "how-to-apply",
    });
  } else {*/
  if( !isQuillEmpty(howToApply) ){
    if (
      countWysyigCharacter(howToApply) < 2 ||
      countWysyigCharacter(howToApply) > 5000
    ) {
      errors.push({
        message: "Please enter text between 2 and 5000 characters",
        scrollDiv: ".benefits-field",
        attrId: "how-to-apply",
      });
    }
  }
  if (availableToStart == "") {
    errors.push({
      message: "Choose when you need candidate to start",
      scrollDiv: ".how-to-apply-field",
      attrId: "field-work-start",
    });
  }
  if (jobType == "") {
    errors.push({
      message: "Choose job type",
      scrollDiv: ".how-to-apply-field",
      attrId: "field-job-type",
    });
  }
  // -- min max salary validation -- //
  if (minSalary === "" || isNaN(minSalary) || Number(minSalary) <= 0) {
    errors.push({
      message: "Enter a valid expected minimum salary greater than 0",
      scrollDiv: "#job-type",
      attrId: "min-salary",
    });
  }
  if (maxSalary != "" && ( isNaN(maxSalary) || Number(maxSalary) <= 0) ){
    errors.push({
      message: "Enter a valid expected maximum salary",
      scrollDiv: "#job-type",
      attrId: "max-salary",
    });
  }
  if (maxSalary != "" && !isNaN(minSalary) && !isNaN(maxSalary)) {
    const min = Number(minSalary);
    const max = Number(maxSalary);
    if (max < min) {
      errors.push({
        message: "Expected maximum salary must be greater than minimum salary",
        scrollDiv: "#job-type",
        attrId: "max-salary",
      });
    }
    if (max > 9000000) {
      errors.push({
        message: "Expected maximum salary must not exceed 9,000,000",
        scrollDiv: "#job-type",
        attrId: "max-salary",
      });
    }
  }
// --- min max salary validation --- //

// if( benefitsChecked != 3 ) {
// errors.push({ message: 'Select top 3 qualities you expect in candidate', scrollDiv: '#min-salary', attrId: 'field-working-environment' });
// }

if (businessEmployerName == "") {
  errors.push({
    message: "Business name is required",
    scrollDiv: ".working-environment",
    attrId: "employer-name",
  });
}
if (businessWebsite == "") {
  // errors.push({ message: 'Business website is required', scrollDiv: '.working-environment', attrId: 'business-website' });
}
if (contactName == "") {
  // errors.push({ message: 'Contact name is required', scrollDiv: '.working-environment', attrId: 'contact-name' });
}
if (contactPhone) {
  if (!/^\d{10}$/.test(contactPhone)) {
    errors.push({
      message: "Enter a valid 10-digit phone number",
      scrollDiv: ".working-environment",
      attrId: "contact-phone",
    });
  }
}
if (contactEmail) {
  if (!validateEmail(contactEmail)) {
    errors.push({
      message: "Enter a valid email",
      scrollDiv: ".working-environment",
      attrId: "contact-email",
    });
  }
}

if (!termsCondition.checked) {
  errors.push({
    message:
      "To continue, please indicate your agreement to the Terms and Conditions.",
    scrollDiv: "#employer-name",
    attrId: "field-terms-condition",
  });
}

const errorElements = document.querySelectorAll(".err");
if (errorElements) errorElements.forEach((el) => el.remove());

if (errors.length > 0) {
  errors.forEach((error) => {
    const errID = document.getElementById(error.attrId);
    const errMessage = error.message;
    if (errID) {
      const p = document.createElement("p");
      p.className = "err";
      p.textContent = errMessage;

      if (error.attrId === "contactNumber") {
        const formElement = errID.closest(".form-element");
        if (formElement) {
          formElement.appendChild(p);
        } else {
          errID.after(p);
        }
      } else {
        errID.after(p);
      }
    }
  });

  // employerCreateJobModal('<p>Please fill in all necessary details to proceed.</p>');

  const target = document.querySelector(errors[0].scrollDiv);
  if (target) target.scrollIntoView({ behavior: "smooth" });

  submitBtn.disabled = false;
  return;
}

const formData = new FormData(employerCreateJob);
formData.append("action", "employer_create_new_job");
formData.append("nonce", ajax_callback_data.ajax_nonce);

const modalElement = document.querySelector(".custom-message-modal-overlay");
if (modalElement) modalElement.classList.add("processing");
const modalCross = document.querySelector(".custom-message-modal-close");
if (modalCross) modalCross.style.display = "none";

const modalTitle = document.querySelector(".custom-message-modal-title");

const modalBody = document.querySelector(".custom-message-modal-body");
if (modalTitle) modalTitle.innerHTML = "Please wait";
if (modalBody) {
  let bodyMessage =
    jobId == 0 ? "Creating new job... " : "Updating job details... ";
  modalBody.innerHTML = `<p>${bodyMessage}</p>`;
}

if (document.querySelector(".custom-message-modal-btn.job-detail")) {
  document.querySelector(".custom-message-modal-btn.job-detail").remove();
}

const modalTriggerBtn = document.querySelector(".open-modal-btn");
if (modalTriggerBtn) {
  modalTriggerBtn.click();
}

fetch(ajax_callback_data.ajax_url, {
  method: "POST",
  body: formData,
})
  .then((res) => res.json())
  .then((data) => {
    if (modalElement) modalElement.classList.remove("processing");
    if (data.success) {
      employerCreateJobModal(
        `<p>${data.data.message}</p>` ||
          (jobId == 0
            ? "<p>New job created.</p>"
            : "<p>Job details updated.</p>"),
        "Confirmation"
      );
      document
        .querySelector(".custom-message-modal-btn.job-detail")
        .classList.add("updated");
      document.querySelector(".custom-message-modal-btn.job-detail").remove();
      document
        .querySelector(".section.dashboard")
        .scrollIntoView({ behavior: "smooth" });

      window.location.href = data.data.redirect;
    } else {
      employerCreateJobModal(
        `<p>${data.data?.message}</p>` ||
          "<p>Something went wrong. Try again.</p>"
      );
    }
  })
  .catch(() =>
    employerCreateJobModal("<p>Something went wrong. Try again.</p>")
  );
});


/* submit end */

/* location suggestion */
// document.addEventListener('DOMContentLoaded', function () {
//   const input = document.getElementById('job-location');
//   if (!input) return;
//
//   let selectedPlace = null;
//
//   const autocomplete = new google.maps.places.Autocomplete(input, {
//     types: ['(regions)'],
//     componentRestrictions: { country: ['AU', 'NZ'] }
//   });
//
//   autocomplete.addListener('place_changed', function () {
//     const place = autocomplete.getPlace();
//     if (!place || !place.formatted_address) {
//       selectedPlace = null;
//       return;
//     }
//     selectedPlace = place.formatted_address;
//     input.value = selectedPlace;
//   });
//
//   // Validate on blur (with slight delay)
//   input.addEventListener('blur', function () {
//     setTimeout(() => { // Delay lets place_changed fire first
//       const typedValue = input.value.trim();
//       console.log(typedValue);
//       // If input is empty, reset
//       if (typedValue === '') {
//         selectedPlace = null;
//         return;
//       }
//
//       // If user typed something that doesn't match selectedPlace, alert
//       if (!selectedPlace || typedValue !== selectedPlace) {
//         selectedPlace = null;
//         input.value = '';
//         employerCreateJobModal('Please select a valid region from the list.');
//         input.focus();
//       }
//     }, 300); // 200ms is enough
//   });
//
//   // Validate again on form submit
//   const form = input.closest('form');
//   if (form) {
//     form.addEventListener('submit', function (e) {
//       if (!selectedPlace || input.value !== selectedPlace) {
//         e.preventDefault();
//         employerCreateJobModal('Please select a valid region from the list.');
//         input.focus();
//       }
//     });
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('job-location');
  if (!input) return;

  let selectedPlace = null;
  let placeSelected = false;

  const autocomplete = new google.maps.places.Autocomplete(input, {
    types: ['(regions)'],
    componentRestrictions: { country: ['AU', 'NZ'] }
  });

  // User starts typing again → invalidate previous selection
  input.addEventListener('input', function () {
    placeSelected = false;
    selectedPlace = null;
  });

  autocomplete.addListener('place_changed', function () {
    const place = autocomplete.getPlace();

    // Ensure a real autocomplete selection happened
    if (!place || !place.place_id) {
      placeSelected = false;
      selectedPlace = null;
      return;
    }

    placeSelected = true;
    selectedPlace = place.formatted_address || input.value;

    input.value = selectedPlace;
  });

  function validateLocation() {
    const typedValue = input.value.trim();

    // Allow empty
    if (typedValue === '') {
      selectedPlace = null;
      placeSelected = false;
      return true;
    }

    // Reject manual text
    if (!placeSelected) {
      input.value = '';
      employerCreateJobModal('Please select a valid region from the list.');
      input.focus();
      return false;
    }

    return true;
  }

  // Blur validation
  input.addEventListener('blur', function () {
    // Longer delay helps Edge/mobile browsers
    setTimeout(validateLocation, 500);
  });

  // Form submit validation
  const form = input.closest('form');

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!validateLocation()) {
        e.preventDefault();
      }
    });
  }
});


/* Save form for later */
// const form = document.getElementById('employer-create-job');
//
// form.addEventListener('input', () => {
//
//   if( document.getElementById("job-id").value != 'create' ) return;
//   const data = {};
//   const elements = form.elements;
//
//   for (let el of elements) {
//     if (!el.name) continue;
//
//     if (el.type === 'checkbox') {
//       if (!data[el.name]) data[el.name] = [];
//       if (el.checked) {
//         data[el.name].push(el.value || true);
//       }
//     }
//
//     else if (el.type === 'radio') {
//       if (el.checked) {
//         data[el.name] = el.value;
//       }
//     }
//
//     else {
//       data[el.name] = el.value;
//     }
//   }
//
//   localStorage.setItem('jobFormData', JSON.stringify(data));
// });
//
// /* load form data if use has one */
// window.addEventListener('load', () => {
//   if( document.getElementById("job-id").value != 'create' ) return;
//
//   const saved = localStorage.getItem('jobFormData');
//   if (!saved) return;
//
//   const data = JSON.parse(saved);
//
//   // restore radios
//   Object.keys(data).forEach(name => {
//     const fields = document.querySelectorAll(`[name="${name}"]`);
//
//     fields.forEach(field => {
//       if (field.type === 'radio' && field.value === data[name]) {
//         field.checked = true;
//       }
//     });
//   });
//
//   // trigger UI (this shows correct selects)
//   document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
//     radio.dispatchEvent(new Event('change', { bubbles: true }));
//   });
//
//   // restore everything else
//   Object.keys(data).forEach(name => {
//     const fields = document.querySelectorAll(`[name="${name}"]`);
//
//     fields.forEach(field => {
//       const type = field.type;
//
//       if (type === 'radio') return; // already handled
//
//       else if (type === 'checkbox') {
//         if (
//             data[name] === true ||
//             data[name] === field.value ||
//             (Array.isArray(data[name]) && data[name].includes(field.value || "on"))
//         ) {
//           field.checked = true;
//         }
//       }
//
//       else if (field.tagName === 'SELECT') {
//         field.value = String(data[name]);
//
//         // required for Select2
//         if (window.jQuery) {
//           jQuery(field).trigger('change');
//         }
//       }
//
//       else {
//         field.value = data[name];
//       }
//     });
//   });
// });


